module.exports = __webpack_public_path__ + "static/media/026-Annies Sur Le Lac.f3f94234.jpg";